export const roles = [
  { text: 'Administrador', value: 'ADMIN' },
  { text: 'Analista', value: 'ANALYST' },
  { text: 'Usuario', value: 'USER' },
];
